import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Faces from 'components/Steps/Faces';
import SimpleCarousel from 'components/SimpleCarousel';
import { Title, MainWrapper } from './styles';

class Likes extends Component {
  render() {
    const { userList, label, onSelectUser } = this.props;
    return (
      <MainWrapper>
        {label && (
          <Title>
            {label}
          </Title>
        )}
        <SimpleCarousel classesList='face_bubble'>
          <Faces
            options={userList}
            onClick={onSelectUser}
            onLongPress={onSelectUser}
          />
        </SimpleCarousel>
      </MainWrapper>
    );
  }
}

Likes.propTypes = {
  userList: PropTypes.array.isRequired,
  onSelectUser: PropTypes.func,
  label: PropTypes.string,
};

Likes.defaultProps = {
  label: null,
  onSelectUser: null,
};


export default Likes;



// WEBPACK FOOTER //
// ./src/components/Steps/Likes/components/Likes.jsx